/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommentMention
 */
export interface CommentMention {
    /**
     * 
     * @type {number}
     * @memberof CommentMention
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof CommentMention
     */
    handle: string;
}

/**
 * Check if a given object implements the CommentMention interface.
 */
export function instanceOfCommentMention(value: object): value is CommentMention {
    let isInstance = true;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;
    isInstance = isInstance && "handle" in value && value["handle"] !== undefined;

    return isInstance;
}

export function CommentMentionFromJSON(json: any): CommentMention {
    return CommentMentionFromJSONTyped(json, false);
}

export function CommentMentionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentMention {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'handle': json['handle'],
    };
}

export function CommentMentionToJSON(value?: CommentMention | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_id': value.userId,
        'handle': value.handle,
    };
}

